import { Component,HostBinding, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { TextosService } from 'src/app/services/textos.service';
import { Empleados } from 'src/app/models/Empleados';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';


@Component({
  selector: 'app-listadoderesguardante',
  templateUrl: './listadoderesguardante.component.html',
  styleUrls: ['./listadoderesguardante.component.css']
})
export class ListadoderesguardanteComponent implements OnInit {

    empleadoss: any = [];

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  cargo:string;
  plantel:string;
  Nombre:string;

 datos=JSON.parse(localStorage.getItem('datos')!); 
  mailusu = this.datos.correop; 
idplantel =this.datos.idplantel;
idplantel1 =this.datos.idplantel;

empleados: Empleados = {
  nombre:"",
  apmaterno:"",
  appaterno:"",
  numpersonal:0,
  idplantel:0,
  rfc:"",
  curp:"",
  plaza:"",
  tipo_trabajador:"",
  puesto:"",
  email:""

}

resetEmpleado() {
this.empleados = {
 nombre:"",
  apmaterno:"",
  appaterno:"",
  numpersonal:0,
  idplantel:0,
  rfc:"",
  curp:"",
   plaza:"",
  tipo_trabajador:"",
  puesto:"",
  email:""
}}

 numpersonal: any =[];

  constructor(private inventarioService: InventarioService, private msj:mensajeSesionExpiradaService,private router:Router, 
       private textosService: TextosService) { 
      this.datos=JSON.parse(localStorage.getItem('datos')!);
    this.cargo=this.datos.cargodb;
    this.idplantel= this.datos.idplantel;
    this.plantel=this.datos.plantel;
    this.Nombre=this.datos.nom; 
  }

  ngOnInit(): void {
      this.dtOptions = {
      pagingType: 'full_numbers',
      order: [], 
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      }
    };
        this.getEmpleados();
  }

getEmpleados(){
    this.inventarioService.getListadeempleados(this.idplantel).subscribe(
      res=>{

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }

      
        this.empleadoss=res;
        console.log(this.empleadoss)
      
        this.dtTrigger.next();

      },
      err=> console.error(err)
    )



  } ;

  guardarempleado(){
     let mailusuario = this.mailusu;
  
    this.inventarioService.createempleado(this.empleados, mailusuario).subscribe(
      res=>{
  
        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();  
          return; 
      }
      Swal.fire({
  title: '<i  style="color:#4CAF50;"></i> ¡Se ha registrado exitosamente!',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Los datos fueron guardados correctamente.</p>',
  icon: 'success',
  iconColor: '#4CAF50',
  confirmButtonText: 'Aceptar',
  confirmButtonColor: '#720f3c',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
});

           setTimeout(function () { location.reload(); }, 1500);
      },
      err=>console.error(err)
    )
  
  }

getEmpleadoInfoId(){
  this.inventarioService.getEmpleadoId(this.numpersonal)
  .subscribe(
    res=> {

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();   
        return;
    }

      this.empleados = res;
     
    },
    err=>console.log(err)
  )

}

verEmpleado(numpersonal:any){
  this.numpersonal=numpersonal;
  this.getEmpleadoInfoId();
  this.inventarioService.getEmpleadoId(numpersonal)
  .subscribe(
    res=> {

      if(res=="TOKEN-EXPIRADO"){
        this.msj.tokenExpiradoCerrarSesion();  
        return; 
    }

      this.empleados = res;
      console.log(this.empleados);
      
    },
    err=>console.log(err)
  )
}

editarproveedor(){
this.inventarioService.updateempleado(this.numpersonal, this.empleados)
    .subscribe(
      res=> {

        if(res=="TOKEN-EXPIRADO"){
          this.msj.tokenExpiradoCerrarSesion();   
          return;
      }  
      Swal.fire({
  title: '<i  style="color:#4CAF50;"></i> ¡Se ha actualizado correctamente!',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Los cambios fueron guardados con éxito.</p>',
  icon: 'success',
  iconColor: '#4CAF50',
  confirmButtonText: 'Aceptar',
  confirmButtonColor: '#720f3c',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
});

           setTimeout(function () { location.reload(); }, 1500);

      },
      err=> console.error(err)
    )
}

eliminarempleado(id:any){
    Swal.fire({
  title: '<i style="color:#d6c07f;"></i> ¿Estás seguro que quieres dar de baja al resguardante?',
  html: '<p style="text-align:center; color:#333; margin:10px 0;">Esta acción no se puede deshacer.</p>',
  icon: 'question',
  iconColor: '#d6c07f',
  showCancelButton: true,
  confirmButtonColor: '#720f3c',
  cancelButtonColor: '#424244',
  confirmButtonText: 'Sí, dar de baja',
  cancelButtonText: 'Cancelar',
  background: '#ffffff',
  customClass: {
    popup: 'animated-popup'
  },
  backdrop: 'rgba(0,0,0,0.3)'
}).then((result) => {

      if (result.isConfirmed) {
        this.inventarioService.deleteempleado(id).subscribe(
          res=>{

            if(res=="TOKEN-EXPIRADO"){
              this.msj.tokenExpiradoCerrarSesion();  
              return; 
          }

            Swal.fire(
              '¡Se dio de baja!',
              '',
              'success',
            )
           setTimeout(function () { location.reload(); }, 1500);
          },
          err=>console.log(err)
        );
      }
    })
  }

}
